import { render, staticRenderFns } from "./PageDeleteAccount.vue?vue&type=template&id=a789d768&scoped=true&"
import script from "./PageDeleteAccount.vue?vue&type=script&lang=ts&"
export * from "./PageDeleteAccount.vue?vue&type=script&lang=ts&"
import style0 from "./PageDeleteAccount.vue?vue&type=style&index=0&id=a789d768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a789d768",
  null
  
)

export default component.exports